"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchButton = exports.SearchBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = require("lodash");
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));
var _SectionNavBar = _interopRequireDefault(require("./SectionNavBar"));
var _ClientPicker = _interopRequireDefault(require("./ClientPicker"));
var _SearchButton = _interopRequireDefault(require("./SearchButton"));
var _SearchBar = _interopRequireDefault(require("./SearchBar"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SearchBar = _SearchBar["default"];
exports.SearchBar = SearchBar;
const SearchButton = _SearchButton["default"];
exports.SearchButton = SearchButton;
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  appBar: {
    boxShadow: 'none',
    overflow: 'hidden',
    background: _episourceColor["default"].epiAnalystBackgroundLight,
    color: _episourceColor["default"].epiAnalystPrimaryDark
  },
  shrink: {
    height: '56.5px !important'
  },
  toolbar: {
    minHeight: 80
  },
  clientPickerToolbar: {
    marginBottom: 16
  },
  searchToolbar: {
    marginBottom: 16
  },
  avatarButton: {
    padding: 0
  },
  searchButton: {
    width: 54,
    height: 54,
    backgroundColor: theme.palette.primary.light,
    marginRight: 12
  },
  searchButtonClose: {
    border: "solid 1px rgba(255, 255, 255, 0.25)"
  },
  avatar: {
    width: '54px',
    height: '54px'
  },
  logoGrouping: {
    'display': 'flex',
    'alignItems': 'center',
    'flexGrow': 1,
    '& > a': {
      'display': 'inline-block',
      'height': '34px',
      '& > img': {
        height: '34px'
      }
    }
  },
  menuButton: {
    'marginRight': theme.spacing(2),
    '& svg': {
      fontSize: '32px'
    }
  },
  fabArea: {
    'display': 'flex',
    'flexDirection': 'row-reverse',
    'height': 0,
    '&.sticky': {
      position: 'fixed',
      top: 50,
      width: '100%',
      zIndex: 100
    }
  },
  fab: {
    width: '60px',
    height: '60px',
    bottom: '30px',
    right: '15%'
  },
  sticky: {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 99
  },
  textField: {
    'paddingRight': 12,
    '& label.MuiFormLabel-root': {
      // color: 'rgba(255, 255, 255, 0.6)',
    },
    '& .MuiInputBase-root': {
      'backgroundColor': _episourceColor["default"].textContrast,
      'border': 'solid 1px',
      'borderRadius': '4px',
      'borderColor': _episourceColor["default"].divider,
      '& input': {
        cursor: 'pointer',
        // color: theme.palette.common.white,
        width: 260
      },
      '&::before': {
        borderBottomStyle: 'none'
      }
    }
    // '& .MuiFilledInput-underline': {
    //   '&::hover': {
    //     '&::before': {
    //       borderColor: episourceColor.epiAnalystPrimaryDark,
    //       borderBottomWidth: '10px',
    //     },
    //   },
    // },
  },

  tooltip: {
    fontSize: 14,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black
  },
  arrow: {
    color: theme.palette.common.white
  },
  badge: {
    right: 28,
    top: 4
  }
}));
const AppBar = /*#__PURE__*/_react["default"].forwardRef(
// eslint-disable-next-line complexity
(_ref, ref) => {
  var _selectedClient$busin;
  let {
    imageLogo,
    logoUrlPath,
    logo,
    primaryNavName,
    navItems,
    onMenuButtonClick,
    avatarInitials,
    avatarPicture,
    onAvatarClick,
    onActionButtonClick,
    hideActionMenu,
    clients,
    clientPickerText,
    selectedClient,
    onClientChange,
    search,
    onCloseSearch,
    enableClientPicker,
    selectedLineOfBusiness
  } = _ref;
  const classes = useStyles({});
  const [isNavBarSticky, setNavBarSticky] = (0, _react.useState)(false);
  const [client, setClient] = (0, _react.useState)(selectedClient);
  const [isClientPickerVisible, setClientPickerVisible] = (0, _react.useState)(false);
  const [newBusinessLine, setNewBusinessLine] = (0, _react.useState)(selectedLineOfBusiness !== null && selectedLineOfBusiness !== void 0 && selectedLineOfBusiness.id ? selectedLineOfBusiness : selectedClient === null || selectedClient === void 0 ? void 0 : (_selectedClient$busin = selectedClient.businessLines) === null || _selectedClient$busin === void 0 ? void 0 : _selectedClient$busin[0]);
  const lobStateDisplay = selectedLineOfBusiness !== null && selectedLineOfBusiness !== void 0 && selectedLineOfBusiness.state ? " - ".concat(selectedLineOfBusiness.state.toUpperCase()) : '';
  const lineOfBusinessDisplay = (selectedLineOfBusiness === null || selectedLineOfBusiness === void 0 ? void 0 : selectedLineOfBusiness.name) === 'medicaid' ? (0, _lodash.capitalize)(selectedLineOfBusiness.name) + lobStateDisplay : 'Medicare';
  const appBarRef = (0, _react.useRef)(null);
  const onChange = (newClient, lineOfBusiness) => {
    setClient(newClient);
    setNewBusinessLine(lineOfBusiness);
    setClientPickerVisible(false);
    if (typeof onClientChange !== 'undefined') {
      if (!client || (client === null || client === void 0 ? void 0 : client.id) !== (newClient === null || newClient === void 0 ? void 0 : newClient.id)) {
        onClientChange(newClient, lineOfBusiness);
      }
      if ((newClient === null || newClient === void 0 ? void 0 : newClient.id) === (client === null || client === void 0 ? void 0 : client.id)) {
        onClientChange(client, lineOfBusiness);
      }
    }
  };
  const onClientPickerClick = () => {
    setClientPickerVisible(!isClientPickerVisible);
    if (onCloseSearch) {
      onCloseSearch();
    }
  };
  (0, _react.useEffect)(() => {
    const scrollCallback = () => {
      if (appBarRef && appBarRef.current) {
        // prevents scroll bouncing issue
        if (window.innerHeight + appBarRef.current.offsetHeight < document.body.clientHeight) {
          if (window.pageYOffset >= appBarRef.current.offsetHeight) {
            setNavBarSticky(true);
          } else {
            setNavBarSticky(false);
          }
        }
        if (window.pageYOffset === 0) {
          setNavBarSticky(false);
        }
      }
    };
    window.addEventListener('scroll', scrollCallback);
    return () => {
      window.removeEventListener('scroll', scrollCallback);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static",
    className: (0, _clsx["default"])(classes.appBar, {
      [classes.shrink]: isNavBarSticky
    }),
    ref: appBarRef
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    edge: "start",
    className: classes.menuButton,
    color: "inherit",
    "aria-label": "menu",
    onClick: onMenuButtonClick
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.logoGrouping
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, logoUrlPath && !logo && /*#__PURE__*/_react["default"].createElement("a", {
    href: logoUrlPath,
    title: "Home"
  }, imageLogo), logo && logo)), clients && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    open: false,
    title: client ? client.name : '',
    arrow: true,
    classes: {
      tooltip: classes.tooltip,
      arrow: classes.arrow
    }
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, enableClientPicker && /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    className: classes.textField,
    InputProps: {
      readOnly: true
    },
    id: "selected-client-display",
    label: clientPickerText || 'Client',
    value: (client === null || client === void 0 ? void 0 : client.name) || '',
    variant: "filled",
    "data-cy": "clientPickerButton",
    onClick: onClientPickerClick
  }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    className: classes.textField,
    InputProps: {
      readOnly: true
    },
    id: "selected-lob-display",
    label: clientPickerText || 'Line of Business',
    value: lineOfBusinessDisplay,
    variant: "filled",
    "data-cy": "clientPickerButton",
    onClick: onClientPickerClick
  }))), /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    invisible: true,
    color: "secondary",
    badgeContent: 3,
    className: classes.badge
  }, /*#__PURE__*/_react["default"].createElement("div", null))), search, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: classes.avatarButton,
    color: "inherit",
    "aria-label": "user-menu",
    onClick: onAvatarClick
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    className: classes.avatar,
    src: avatarPicture
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h4"
  }, avatarInitials)))), isClientPickerVisible && clients && /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.clientPickerToolbar,
    "data-cy": "clientPickerToolbar"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ClientPicker["default"], {
    clients: clients,
    clientPickerText: clientPickerText,
    selectedClient: client || undefined,
    onChange: onChange,
    onCancel: () => {
      setClientPickerVisible(false);
    },
    selectedLineOfBusiness: newBusinessLine,
    enableClientPicker: enableClientPicker
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])({
      [classes.sticky]: isNavBarSticky
    })
  }, /*#__PURE__*/_react["default"].createElement(_SectionNavBar["default"], {
    primaryNavName: primaryNavName,
    navItems: navItems
  })), !hideActionMenu && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.fabArea, {
      sticky: isNavBarSticky
    })
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    onClick: onActionButtonClick,
    color: "secondary",
    "aria-label": "actions",
    className: classes.fab,
    "aria-haspopup": "true"
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null))));
});
var _default = AppBar;
exports["default"] = _default;